import { CodeIcon } from 'foundations-assets/icons/components/CodeIcon';
import { PaidAdIcon } from 'foundations-assets/icons/components/PaidAdIcon';
import { SiteTreeIcon } from 'foundations-assets/icons/components/SiteTreeIcon';
import { WebsiteIcon } from 'foundations-assets/icons/components/WebsiteIcon';
export const CAROUSEL_SERVICES_QA = [{
  color: 'fill-accent-purple-subtle',
  icon: WebsiteIcon,
  iconUrl: 'WebsiteIcon',
  slug: 'website-development'
}, {
  color: 'fill-accent-blue-subtle-alt',
  icon: SiteTreeIcon,
  iconUrl: 'CustomModulesIcon',
  slug: 'website-design'
}, {
  color: 'fill-accent-green-subtle-alt',
  icon: CodeIcon,
  iconUrl: 'IntegrationsIcon',
  slug: 'customer-integrations'
}, {
  color: 'fill-accent-yellow-subtle-alt',
  icon: PaidAdIcon,
  iconUrl: 'ReportsIcon',
  slug: 'account-based-marketing'
}, {
  iconUrl: 'SalesQuoteIcon',
  slug: 'paid-advertising'
}, {
  iconUrl: 'TagIcon',
  slug: 'full-inbound-marketing-services'
}, {
  iconUrl: 'EditIcon',
  slug: 'content-creation'
}, {
  iconUrl: 'WorkflowsIcon',
  slug: 'sales-enablement'
}, {
  iconUrl: 'LogEmailIcon',
  slug: 'email-marketing'
}, {
  iconUrl: 'CapIcon',
  slug: 'sales-coaching-and-training'
}, {
  iconUrl: 'ContactDuplicateIcon',
  slug: 'customer-marketing'
}, {
  iconUrl: 'SalesTemplatesIcon',
  slug: 'sales-and-marketing-alignment'
}];
export const CAROUSEL_SERVICES_PROD = [{
  color: 'fill-accent-purple-subtle',
  icon: WebsiteIcon,
  iconUrl: 'WebsiteIcon',
  slug: 'website-development'
}, {
  color: 'fill-accent-blue-subtle-alt',
  icon: SiteTreeIcon,
  iconUrl: 'CustomModulesIcon',
  slug: 'website-design'
}, {
  color: 'fill-accent-green-subtle-alt',
  icon: CodeIcon,
  iconUrl: 'IntegrationsIcon',
  slug: 'customer-integrations'
}, {
  color: 'fill-accent-yellow-subtle-alt',
  icon: PaidAdIcon,
  iconUrl: 'ReportsIcon',
  slug: 'account-based-marketing'
}, {
  iconUrl: 'SalesQuoteIcon',
  slug: 'paid-advertising'
}, {
  iconUrl: 'TagIcon',
  slug: 'full-inbound-marketing-services'
}, {
  iconUrl: 'EditIcon',
  slug: 'content-creation'
}, {
  iconUrl: 'WorkflowsIcon',
  slug: 'sales-enablement'
}, {
  iconUrl: 'LogEmailIcon',
  slug: 'email-marketing'
}, {
  iconUrl: 'CapIcon',
  slug: 'sales-coaching-and-training'
}, {
  iconUrl: 'ContactDuplicateIcon',
  slug: 'customer-marketing'
}, {
  iconUrl: 'SalesTemplatesIcon',
  slug: 'sales-and-marketing-alignment'
}];
export const SUGGESTED_FILTERS = [{
  buttonText: 'Find CRM implementation partners',
  description: 'Partners with proven experience delivering large scale, complex implementations of the HubSpot platform.',
  slug: '/crm-implementation',
  name: 'CRM Implementation'
}, {
  buttonText: 'Find Onboarding partners',
  description: 'Partners with proven experience onboarding for the Pro and Enterprise editions of Marketing and Sales Hubs.',
  slug: '/onboarding',
  name: 'Onboarding'
}, {
  buttonText: 'Find Custom Integration partners',
  description: 'Partners with proven experience in deploying complex, custom integrations based on unique client requirements.',
  slug: '/custom-integration',
  name: 'Custom Integration'
}, {
  buttonText: 'Find Data Migration partners',
  description: 'Partners with proven experience migrating data from legacy platforms and systems into the HubSpot platform.',
  slug: '/data-migration',
  name: 'Data Migration'
}, {
  buttonText: 'Find Platform Enablement partners',
  description: 'Partners with proven experience driving user adoption for large teams through customized training engagements and materials.',
  slug: '/platform-enablement',
  name: 'Platform Enablement'
}, {
  buttonText: 'Find Solutions Architecture Design partners',
  description: 'Partners with proven experience designing and configuring complex solutions across the HubSpot platform.',
  slug: '/solutions-architecture-design',
  name: 'Solutions Architecture Design'
}];